import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from "@ngx-translate/core";

import { DialogInformationComponent } from './dialog-information.component';
import { FormModule } from "../../default/form/form.module";
import { PipesModule } from "../../../pipes/pipes.module";
import { HtmlRenderModule } from "../html-render/html-render.module";


@NgModule({
    declarations: [
        DialogInformationComponent
    ],
    imports: [
        CommonModule,
        FormModule,
        TranslateModule,
        PipesModule,
        HtmlRenderModule
    ],
    exports: [DialogInformationComponent]
})
export class DialogInformationModule {
}
